import type { list_availability_status } from '../constant/listBook.constant';
import type { ProductAvailability, ProductPrices } from '../types/product.types';

export interface PriceView {
  /** The Harga Asli is shown crossed out only when the customer pays less */
  hasDiscount: boolean;
  original: number;
  final: number;
}

export const priceView = ({ price, final_price }: ProductPrices): PriceView => {
  const original = Number(price);
  const final = Number(final_price);
  return { hasDiscount: final < original, original, final };
};

export const formatPrice = (value: number) => new Intl.NumberFormat('id-ID').format(value);

/** Badge key of AVAILABILITY_STATUS for an availability from the API. */
export const availabilityStatus = (availability: ProductAvailability): list_availability_status =>
  availability === 'preorder' ? 'preOrder' : 'ready';
